import React, {useEffect, useState} from "react";
import ReactApexChart from "react-apexcharts";
import "../../index.css";
import log from "../adminPage/Log";

const AreaChart = ({data}) => {
    const [chatSeries, setChatSeries] = useState([
        {
            name: "Series 1",
            data: [],
        },
    ])
    const [categories, setCategories] = useState([])
    useEffect(() => {
        if (data?.chartData) {
            const listOfX = data.chartData.map((d) => d.x);
            const category = data.chartData.map((d) => d.z);
            setCategories(category)
            setChatSeries([
                {
                    name: "Series 1",
                    data: listOfX, // مقداردهی صحیح
                },
            ]);
        }
    }, [data]); // وابستگی به data اضافه شد


    const options = {
        colors: ["#5868E0"],
        chart: {
            fontFamily: "Kalameh",
            type: "area",
            height: 150,
            zoom: {enabled: false},
            toolbar: {show: true, tools: {download: false}},
        },
        fill: {
            type: "gradient",
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.6,
                opacityTo: 0.2,
                stops: [0, 90, 100],
            },
        },
        stroke: {
            show: true,
            curve: "smooth",
            width: 2,
        },
        plotOptions: {area: {fillTo: "end"}},
        dataLabels: {enabled: false},
        xaxis: {
            type: "category",
            categories:categories,
            label: {
                show: Boolean,
                rotate: Number,
            },
        },
        grid: {
            show: true,
            borderColor: "#E9F1F9",
            strokeDashArray: 2,
        },
        tooltip: {
            enabled: true,
            custom: function ({series, seriesIndex, dataPointIndex}) {
                if (!data.chartData || !data.chartData[dataPointIndex]) return "";
                return `
                    <div class="arrow_box">
                        <span>تاریخ: ${data.chartData[dataPointIndex].y}</span>
                        <span>${data.selectedType}: ${series[seriesIndex][dataPointIndex]} 
                        ${data.selectedType === "تعداد تراکنش" ? "عدد" : "تومان"}</span>
                    </div>
                `;
            },
        },
    };



    return (
        <div id="chart">
            <ReactApexChart series={chatSeries} options={options} type="area" height={350}/>
        </div>
    );
};

export default AreaChart;

